import React, { useEffect } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { updateSelectVariable } from "../../../../../store/reducers/pdfeditor/toolsModificationSlice";
import { updateCoordinate } from "../../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import { BorderColor } from "@mui/icons-material";

const FontSizeHover = ({settedFontSize}) => {
  const dispatch = useDispatch();
  const { fontSize, currVariable } = useSelector(
    (state) => state.toolsModification
  );
  const {coordinates} = useSelector((state) => state.pdfCoordinates);
console.log('setted fontsize', settedFontSize)
console.log('setted fontsize currentvariable', currVariable)
console.log('setted fontsize coordinate', coordinates)

  const handleChangeFontSize = (e) => {
    let value = Number(e.target.value);
    console.log("currvariable data is handlechangefontsize: ",value)
    let data = { fontSize: value };
    if (value >= 0 && value < 25 && !currVariable?.variable) {
      dispatch(updateSelectVariable(data));
      dispatch(
        updateCoordinate({ id: currVariable?.id || currVariable?.variable, newValue: data })
      );
    } else if (value >= 0 && value < 25) {
      dispatch(updateSelectVariable(data));
      dispatch(
        updateCoordinate({ id: currVariable?.id || currVariable?.variable, newValue: data })
      );
    } 
  };

  const handleKeyPress = (e) => {
    console.log("setted fontsize pressseddddddd")
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
      let newValue = currVariable?.fontSize || fontSize;
    //   let newValue = fontSize;
      if (e.key === "ArrowUp") {
        newValue = Math.min(newValue + 1, 24);
      } else if (e.key === "ArrowDown") {
        newValue = Math.max(newValue - 1, 0);
      }

      let data = { fontSize: newValue,'font-size':newValue };
      if (!currVariable?.variable) {
        dispatch(updateSelectVariable(data));
        dispatch(
          updateCoordinate({ id: currVariable?.id || currVariable?.variable, newValue: data })
        );
      } else {
        dispatch(updateSelectVariable(data));
        dispatch(
          updateCoordinate({ id: currVariable?.id ||  currVariable?.variable, newValue: data })
        );
      }
    }
  };

  return (
    <Wrapper>
      <div style={{  alignItems: "center", width: "55px",position:'relative', left:'38px' }}>
      {/* <div style={{  alignItems: "center", width: "55px",position:'relative', left:'34px',top:'8px' }}> */}

        <input
          value={settedFontSize?settedFontSize:fontSize}
          onChange={handleChangeFontSize}
          style={inputStyle}
          disabled={currVariable?.data_type === "image"}
          onKeyDown={handleKeyPress}
          type="number"
          autoFocus
        />
        {/* <label style={{position:'absolute',top:0, left:0, fontSize:'10px',margin:'2px 5px',fontWeight:'bold'}}>Font Size</label> */}
      </div>
    </Wrapper>
  );
};

export default FontSizeHover;
const inputStyle = {
  width: "100%",
  height: "33px",
  borderRadius:'5px',
  // border:'2px solid black'
};
const Wrapper = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .size-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 22%;
  }
  p {
    font-size: 12px;
    margin-right: 5px;
    white-space: nowrap;
  }
`;
